// React
import { Col, Row } from 'reactstrap';
import React, { useState, useEffect } from 'react';

// Yup Validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Containers Injections
import { CardList } from '../../../../containers/componentsInjection';
import {
  url,
  APIClient,
  useLoading,
} from '../../../../helpers/helpersInjection';
import { CredentialsNTInjection } from '../../../../containers/credentialsNTInjection';

// Components
import { ModalProviderSpecialty } from './components/ModalProviderSpecialty';

const CardSpecialties = ({ credential }) => {
  const [specialty, setSpecialty] = useState(null);
  const [modal_animationLeft, setmodal_animationLeft] = useState(false);
  function tog_animationLeft() {
    setSpecialty(null);
    setmodal_animationLeft(!modal_animationLeft);
  }

  const api = new APIClient();
  const { loadingWithTime } = useLoading();

  const {
    specialties,
    providerSpecialty,
    getSpecialties,
    getProviderSpecialty,
    createProviderSpecialty,
    updateProviderSpecialty,
    deleteProviderSpecialty,
    success_providerSpecialty,
  } = CredentialsNTInjection();

  const getProviderSpecialtyById = async (id) => {
    const response = await api.get(
      url.BASE + `/register/provider-specialty/${id}`
    );

    if (response) {
      setSpecialty(response);
    }
  };

  const data = specialties.map((item) => {
    return {
      value: item.id,
      label: item.name,
    };
  });

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      benefitsInput: specialty ? specialty.benefits : '',
      selectInput: specialty
        ? {
            label: specialty.specialty_name,
            value: specialty.specialty_id,
          }
        : {
            label: '',
            value: '',
          },
    },
    validationSchema: Yup.object({
      benefitsInput: Yup.string(),
      selectInput: Yup.object().shape({
        label: Yup.string().nullable(),
        value: Yup.string()
          .nullable()
          .required('Tipo de Especialidade é obrigatório'),
      }),
    }),

    onSubmit: (values) => {
      const valuesToSubmit = {
        provider_id: credential.id || null,
        specialty_id: values.selectInput.value || null,
        benefits: values.benefitsInput || null,
      };

      loadingWithTime(1000);
      if (specialty) {
        updateProviderSpecialty(specialty.id, {
          ...valuesToSubmit,
          id: specialty.id,
        });
      } else {
        createProviderSpecialty(valuesToSubmit);
      }
      tog_animationLeft();
      validation.resetForm();
    },
  });

  const handleDelete = (values) => {
    const { id } = values;

    deleteProviderSpecialty(id);
  };

  const handleEdit = (values) => {
    tog_animationLeft();
    getProviderSpecialtyById(values.id);
  };

  useEffect(() => {
    if (credential) {
      getSpecialties();
      getProviderSpecialty(credential.id);
    }
  }, [credential, success_providerSpecialty]);

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Nome</span>,
      sortable: true,
      width: '30%',
      selector: (cell) => {
        return (
          <ul
            className="list-inline hstack gap-2 mb-0 "
            style={{
              width: '100%',
              display: 'flex',
              alignSelf: 'center',
            }}
          >
            <li className="list-inline-item" title="Remove">
              {cell.specialty_name}
            </li>
          </ul>
        );
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Benefícios</span>,
      selector: (row) => (row.benefits || '').substring(0, 80),
      sortable: true,
    },
  ];

  return (
    <React.Fragment>
      <Row>
        <Col
          xs={12}
          style={{
            marginTop: -24,
          }}
        >
          <CardList
            isCard
            perPage={10}
            columns={columns}
            keySearch={'specialty_name'}
            titleButton="Nova Especialidade"
            data={providerSpecialty ? providerSpecialty : []}
            title={`Especialidades de ${credential ? credential.name : ''}`}
            handleButton={tog_animationLeft}
            pagination
            persistTableHead
            paginationServer
            isSearch={false}
            isSearchRemote={false}
            actions={[
              {
                id: 1,
                name: 'edit',
                label: 'Editar',
                onPress: (cellProps) => handleEdit(cellProps),
                icon: 'las la-pen',
                classNameColorIcon: 'primary',
              },
            ]}
            handleDelete={(cellProps) => handleDelete(cellProps)}
          />
        </Col>
      </Row>

      <ModalProviderSpecialty
        options={data}
        validation={validation}
        toogle={tog_animationLeft}
        isOpen={modal_animationLeft}
        handleBack={tog_animationLeft}
        id={specialty ? specialty.id : null}
      />
    </React.Fragment>
  );
};

export default CardSpecialties;
